export default __webpack_public_path__ + "static/result_back-5729f49cf2dc99e4a87f3eb80730d51f.png";